var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CommissionHistory.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8cfde4ba\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CommissionHistory.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/VenderTradeTable/CommissionHistory.vue
// module id = 2281
// module chunks = 1